import { render, staticRenderFns } from "./SettingsSourceTypes.vue?vue&type=template&id=4780adf0&scoped=true"
import script from "./SettingsSourceTypes.vue?vue&type=script&lang=js"
export * from "./SettingsSourceTypes.vue?vue&type=script&lang=js"
import style0 from "./SettingsSourceTypes.vue?vue&type=style&index=0&id=4780adf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4780adf0",
  null
  
)

export default component.exports